import { writable } from 'svelte/store';

export function parseNotice(value) {
  if (!value || value.schema !== 1 || typeof value.maintenance !== 'boolean' || typeof value.block_new_requests !== 'boolean' || typeof value.message !== 'string') return null;
  for (const field of ['starts_at', 'expected_end_at', 'updated_at']) {
    if (value[field] != null && (typeof value[field] !== 'string' || !/(Z|[+-]\d{2}:\d{2})$/.test(value[field]) || !Number.isFinite(Date.parse(value[field])))) return null;
  }
  if (value.starts_at && value.expected_end_at && Date.parse(value.expected_end_at) <= Date.parse(value.starts_at)) return null;
  return value;
}
export function noticeIsActive(notice, now = Date.now()) {
  return Boolean(notice?.maintenance || (notice?.starts_at && Date.parse(notice.starts_at) <= now));
}
export function serviceState(ready, notice, now = Date.now()) {
  const phase = noticeIsActive(notice, now) ? 'maintenance' : ready === null ? 'checking' : ready ? 'available' : 'unavailable';
  return { phase, notice, blocksNewRequests: phase !== 'available' || Boolean(notice?.block_new_requests) };
}
export const serviceStore = writable(serviceState(null, null));
